import { Injectable, Injector } from "@angular/core";
import { LocalStorageService } from "@app/shared/services/local-storage/local-storage.service";
import { BehaviorSubject, Observable } from "rxjs";
import { MenuService } from "./menu.service";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  public currentUserRoleSubject: BehaviorSubject<any>;
  public currentUserRole: Observable<any>;

  // Returns current user role value
  public get currentUserRoleValue(): any {
    return this.currentUserRoleSubject.value;
  }

  public currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;

  // Returns current user data value
  public get currentUserData(): any {
    return this.currentUserSubject.value;
  }

  private _menuService: MenuService;

  // Lazily resolves MenuService to avoid circular dependency
  private get menuService(): MenuService {
    if (!this._menuService) {
      this._menuService = this.injector.get(MenuService);
    }
    return this._menuService;
  }

  constructor(
    private localStorageService: LocalStorageService,
    private injector: Injector,
  ) {
    this.currentUserRoleSubject = new BehaviorSubject<any>(
      this.localStorageService.getLocalStorageItem("role"),
    );
    this.currentUserRole = this.currentUserRoleSubject.asObservable();

    this.currentUserSubject = new BehaviorSubject<any>(
      this.localStorageService.getLocalStorageItem("user_info"),
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  // Returns menu from in-memory MenuService (fallback safe)
  private getMenu(): any[] {
    return this.menuService.getMenuSnapshot();
  }

  // Returns current menu snapshot
  getRole(): any[] {
    return this.getMenu();
  }

  // Checks if given angular_route exists in user menu
  hasRoleBypath(routeParam: string): boolean {
    if (!routeParam) {
      return false;
    }

    const userMenu = this.getMenu();

    if (userMenu === null) {
      return false;
    }

    const cleanedRoute = routeParam.split("?")[0].replace(/\/+$/, "");

    // Log every angular_route in the menu so you can see exactly what the backend returned
    // const allRoutes = userMenu.map((m) => m.angular_route);
    // console.log(
    //   `[AuthService] hasRoleBypath("${cleanedRoute}") — menu has ${userMenu.length} items`,
    // );
    // console.log("[AuthService] all angular_routes in menu:", allRoutes);

    const match = userMenu.some((menu) => {
      if (!menu.angular_route) return false;
      const menuRoute = menu.angular_route.split("?")[0].replace(/\/+$/, "");
      const isMatch = menuRoute === cleanedRoute;
      // Only log near-misses — routes that differ only by slash/case — so you can spot typos
      if (!isMatch && menuRoute.toLowerCase() === cleanedRoute.toLowerCase()) {
      }
      return isMatch;
    });

    return match;
  }

  // Checks if parentMenuRoute exists in user menu
  hasRole(route: any, url?: string): boolean {
    const parentRoute =
      route.data && route.data.parentMenuRoute
        ? route.data.parentMenuRoute
        : null;

    if (!parentRoute) {
      return false;
    }

    const userMenu = this.getMenu();
    if (!userMenu) {
      return false;
    }

    const match = userMenu.find((x) => x.angular_route === parentRoute);

    return match != null;
  }
}
